/**
 * useRefreshData — force a genuine reload for React Query pages.
 *
 * The server caches DAX results for 10 minutes keyed by dataset ID, and React
 * Query caches on top of that. Invalidating React Query alone just re-reads the
 * server's cache, so a real refresh has to clear the server first and only then
 * refetch — which is why this is a hook and not a bare `invalidateQueries`.
 */

import { useCallback, useState } from "react";
import { useQueryClient } from "@tanstack/react-query";
import { clearApiCache } from "../utils/PowerBIApiCall";

export function useRefreshData() {
  const queryClient = useQueryClient();
  const [refreshing, setRefreshing] = useState(false);

  const refresh = useCallback(async () => {
    setRefreshing(true);
    try {
      // Server cache first, so the refetch below cannot be served a stale hit.
      await clearApiCache();
      await queryClient.invalidateQueries();
    } finally {
      setRefreshing(false);
    }
  }, [queryClient]);

  return { refresh, refreshing };
}
